<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/oilBenzene')">石油苯</span> > <span
        @click="back('/oilBenzene/twoPage/enterprise')" style="cursor: pointer">化工重点企业资讯</span> > 正文
    </div>
    <DetailTitle :title="endTime + '化工重点企业资讯'"></DetailTitle>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        height="700"
        border
        style="width: 100%;margin-top: 20px;margin-bottom: 30px">
      <el-table-column
          type="index"
          fixed
          label="序号"
          width="50">
      </el-table-column>
      <el-table-column
          align="left"
          fixed
          prop="companyName"
          width="200px"
          label="客户名称">
      </el-table-column>
      <el-table-column
          align="center"
          prop="cityName"
          label="城市">
      </el-table-column>
      <el-table-column
          align="center"
          prop="totalCapacity"
          label="总产能（万吨）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="materialName"
          label="原料名称">
      </el-table-column>
      <el-table-column
          align="center"
          prop="materialBuyNumber"
          label="原料采购量(吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="industryNumDay"
          label="原料库存可用天数（天）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="productName"
          label="产品名称">
      </el-table-column>
      <el-table-column
          align="center"
          prop="productSaleNumber"
          label="产品销售量（吨）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="partnership"
          label="与我司合作量">
      </el-table-column>
      <el-table-column
          align="center"
          prop="openRate"
          label="开工率（%）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="workRatioRemark"
          label="开工率影响原因">
      </el-table-column>
      <el-table-column
          align="center"
          prop="materialStockChange"
          label="原料库存变化（吨）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="productStockChange"
          label="产品库存变化（吨）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="tonProfit"
          label="吨盈利（元/吨）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="industry"
          label="运距(公里)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="freight"
          label="运价(元/吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="weekAveragePrice"
          label="周订货均价(元/吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="thisWeek"
          label="与我公司周合作量(吨)">
      </el-table-column>

      <el-table-column
          align="center"
          label="比上周（计算）">
        <el-table-column
            align="center"
            prop="lastOpenRate"
            label="开工率（%）">
        </el-table-column>
        <el-table-column
            align="center"
            prop="lastMaterialStockChange"
            label="原料库存变化（吨）">
        </el-table-column>
        <el-table-column
            align="center"
            prop="industryNumDayChange"
            label="原料可用天数变化（天）">
        </el-table-column>
        <el-table-column
            align="center"
            prop="lastProductStockChange"
            label="产品库存变化（吨）">
        </el-table-column>
        <el-table-column
            align="center"
            prop="lastTonProfit"
            label="盈利变化（元/吨）">
        </el-table-column>
      </el-table-column>
      <el-table-column
          align="center"
          prop="remark"
          width="500px"
          label="简要说明">
      </el-table-column>
      <el-table-column
          align="center"
          prop="servicePeople"
          label="业务员">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {examineDetail} from '@/api/oilBenzene'

export default {
  components: {
    DetailTitle
  },
  data() {
    return {
      endTime: '',
      tableData: [],
    }
  },
  created() {
    this.endTime = this.$route.query.id;
    this.getDetail()
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      examineDetail({collectionTime: this.endTime}).then(res => {
        this.tableData = res.data;
      })
    },
    back(url) {
      this.$router.push({path: url});
    },
  },
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .slot-span:hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .slot-hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }
}

</style>
